export const CAMPS = {
  FETCH_CAMPS_REQUEST: 'FETCH_CAMPS_REQUEST',
  FETCH_CAMPS_SUCCESS: 'FETCH_CAMPS_SUCCESS',
  FETCH_CAMPS_FAILURE: 'FETCH_CAMPS_FAILURE',
};
